// 列表
import { Http } from '@main/common/api/index.js'

export const listUrl = '/file/download/record/page'

export const apiDeleteByUserId = async () => Http.delete('/file/download/record/deleteByUserId')
